import { render } from "./BannerCarouselPanel.vue?vue&type=template&id=6ad7ba27&scoped=true"
import script from "./BannerCarouselPanel.vue?vue&type=script&lang=js"
export * from "./BannerCarouselPanel.vue?vue&type=script&lang=js"

import "./BannerCarouselPanel.vue?vue&type=style&index=0&id=6ad7ba27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad7ba27"]])

export default __exports__